import { render, staticRenderFns } from "./card.vue?vue&type=template&id=5028a24c&scoped=true&"
import script from "./card.vue?vue&type=script&lang=js&"
export * from "./card.vue?vue&type=script&lang=js&"
import style0 from "./card.vue?vue&type=style&index=0&id=5028a24c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028a24c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5028a24c')) {
      api.createRecord('5028a24c', component.options)
    } else {
      api.reload('5028a24c', component.options)
    }
    module.hot.accept("./card.vue?vue&type=template&id=5028a24c&scoped=true&", function () {
      api.rerender('5028a24c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/overview/common/cards/card.vue"
export default component.exports